import React, {useState, useEffect} from "react";
import { useMemo } from "react";
import MetaTags from 'react-meta-tags';
import { Link } from "react-router-dom";
import { Col, Container, Form, Row, Input, Label, FormFeedback } from "reactstrap";

import axios from 'axios';
import { HRConfig2, TOAST_OPTIONS2, formatDate } from "../../helpers/backend_helper"
import * as url from 'helpers/url_helper';

import toastr from "toastr";
import "toastr/build/toastr.min.css";
import { useHistory } from "react-router-dom";
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import 'react-phone-number-input/style.css';
import PhoneInput from "react-phone-number-input";
import Select from 'react-select';
import countryList from 'react-select-country-list'
import validator from "validator";

// import images
import logodark from "../../assets/images/logo-dark.png";
import CarouselPage from "./CarouselPage";

const PublicApplicantsRegister = () => {
  const history = useHistory()
  toastr.options = TOAST_OPTIONS2;
  const [firstName, setFirstName] = useState("")
  const [middleName, setMiddleName] = useState('')
  const [lastName, setLastName] = useState('')
  const [dateofbirth, setDateofBirth] = useState('')
  const [gender, setGender] = useState('')
  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [country, setCountry] = useState('')
  const options = useMemo(() => countryList().getData(), [])
  const [customchkSuccess, setcustomchkSuccess] = useState(true);
  const [message, setMessage] = useState(" ");

  const changeHandler = country => {
    setCountry(country)
  }   
  function handleEmail(event) {
    let new_Email = event.target.value;
    setEmail(new_Email);
    if (!validator.isEmail(new_Email)) {
      setMessage("Please, enter a valid email!");
      console.log(message)
    } else {
      setMessage("");
      console.log(message)
    }
  }
  
  const handleRegister = () =>{
    if(firstName.trim().length < 2){
      toastr.error('Enter your First Name')
    }else if(lastName.trim().length < 2){
      toastr.error('Enter your Last Name')
    }else if(dateofbirth == ""){
      toastr.error("Enter your Date of birth");
    }else if(gender == ""){
      toastr.error("Enter your Gender assigned at birth");
    }else if(country == ""){
      toastr.error("Enter your country/region of origin");
    }else if(email.trim().length < 5){
      toastr.error('Enter a valid email address')  
    }else if(phone.trim().length < 8){
      toastr.error('Your telephone contact must not be less than 8 characters inclusive of country/area code!')
    }else if(phone.trim().length > 15){
      toastr.error('Your telephone contact must not be greater than 16 characters inclusive of country/area code!')
    }else if(phone.trim().value > 0){
      toastr.error('Your telephone contact must not be a negative number!')
    }else if(message.trim() == "Please, enter a valid email!"){
      toastr.error('Please enter a valid email!')
    }else{
      const data = {
        firstName: firstName,
        middleName: middleName,
        lastName: lastName,
        gender: gender,
        dateofbirth: formatDate(dateofbirth),
        country: country.label,
        email: email,
        phone: phone,
        changePass: "Yes",
        action: "add"

      }
      setIsLoading(true)
      axios.post(url.APPLICANT_REGISTER, JSON.stringify(data), HRConfig2).then((r)=>{
        if(r.data.status == '1'){
          toastr.success(r.data.message)
          setFirstName('')
          setLastName('')
          setEmail('')
          setPhone('')
          history.push('/applicants-login')
        }else{
          toastr.error(r.data.message)
        }
        setIsLoading(false)
      }).catch((e)=>{
        console.log(e)
        setIsLoading(false)
      })
    }
  }

  return (
    <React.Fragment>
      <div>
        <MetaTags>
          <title>Sign up | MILDMAY E-Recruitment</title>
        </MetaTags>
        <Container fluid className="p-0">
          <Row className="g-0">
            <Col xl = {6}>
            <CarouselPage />
            </Col>

            <Col xl={6}>
              <div className="auth-full-page-content p-md-5 p-4" style={{ backgroundColor: 'white' }}>
                <div className="w-100">
                  <div className="d-flex flex-column h-100">
                    <div className="mb-4 mb-md-5">
                      <Link to="#" className="d-block auth-logo">
                        <img
                          src={logodark}
                          alt=""
                          height="78"
                          className="auth-logo-dark"
                        />
                        
                      </Link>
                    </div>
                    <div className="my-auto">
                      <div>
                        <h5 className="text-primary">Register Account</h5>
                        <p className="text-muted">
                          Details will be used to access and apply for vacancies
                        </p>
                      </div>

                      <div className="mt-4">
                        <Form 
                        className="form-horizontal"
                          onSubmit={(e) => {
                            e.preventDefault();
                            return false;
                          }}
                        >
                        <Row>
                          <Col xl = {6}>
                            <div className="mb-3">
                              <Label className="form-label">First Name</Label>
                              <input 
                                className="form-control" 
                                type="text" 
                                value={firstName} 
                                onChange={(e)=>setFirstName(e.target.value)}
                              />
                            </div>

                            <div className="mb-3">
                              <Label className="form-label">Middle Name</Label>
                              <input  
                                className="form-control" 
                                type="text" 
                                value={middleName} 
                                onChange={(e)=>setMiddleName(e.target.value)}  
                              />
                            </div>

                            <div className="mb-3">
                              <Label className="form-label">Last Name</Label>
                              <input  
                                className="form-control" 
                                type="text" 
                                value={lastName} 
                                onChange={(e)=>setLastName(e.target.value)} 
                              />
                            </div>

                            <div className="mb-3">
                              <Label className="form-label">Date of birth</Label>
                              <Flatpickr
                                  className="form-control"
                                  onChange={(date)=>setDateofBirth(date)}
                                  value={dateofbirth}
                                  placeholder="dd M,yyyy"
                                  options={{
                                      dateFormat: "d-m-Y",
                                      enableTime: false,
                                      maxDate: "today"
                                  }} 
                              />
                            </div>
                          </Col>

                          <Col xl = {6}>
                            <div className="mb-3">
                              <Label className="form-label">Gender</Label>
                              <select className="form-select" 
                                value={gender} 
                                onChange={(e)=>setGender(e.target.value)}>
                                <option value="">Select</option>
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                              </select>
                            </div>

                            <div className="mb-3">
                              <Label className="form-label">Country/Region</Label>
                              <Select options={options} 
                                value={country} 
                                onChange={changeHandler}
                                placeholder="Select the country or region of origin.">
                              </Select>
                            </div>

                            <div className="mb-3">
                              <Label className="form-label">Email Address</Label>
                              <div style = {{ color: "red" }}> {message} </div>
                              <input 
                                className="form-control" 
                                type="email" 
                                value={email} 
                                onChange={handleEmail}
                              />
                            </div>

                            <div className="mb-3">
                              <Label className="form-label">Phone contact</Label>
                              <input 
                                className="form-control" 
                                type="text" 
                                value={phone} 
                                onChange={(e)=>setPhone(e.target.value)}  
                              />
                            </div>
                          </Col>
                        </Row>

                         <Row>
                          <Col xl = {6}>
                            <div className="form-check form-check-success mb-3">
                              <Label className="form-label">
                                <p className="mb-0">
                                  By registering you agree to the MILDMAY{" "} 
                                  <a href="#" className="text-primary">
                                    Terms of Use
                                  </a>
                                </p>
                              </Label>
                             <input 
                                className="form-check-input" 
                                type="checkbox"
                                id="customCheckcolor2"
                                checked={customchkSuccess}
                                onChange={() => {
                                  setcustomchkSuccess(!customchkSuccess)
                                }} 
                              />
                            </div>
                          </Col>
                        </Row>                     

                          <Row>
                          <Col xs={6}>
                          <div className="hstack gap-2">
                            {isLoading?(
                              <button className="btn btn-warning btn-block w-100 " type="button">Please wait...</button>
                            ):(
                              <button className="btn btn-primary btn-block w-100 " type="submit"  onClick={handleRegister}>Register</button>
                            )}
                            </div>
                            </Col>
                            <Col xs={6}>
                            <div className="hstack gap-2">
                              {isLoading?(
                              <button className="btn btn-warning btn-block w-100 " type="button">Please wait...</button>
                              ):(
                              <button className="btn btn-info btn-block w-100 " type="button"  onClick={() => {history.push(`/applicants-login`)}}>Log In</button>
                              )}
                            </div>
                            </Col>
  
                          </Row>
                          

                        </Form>
                      </div>
                    </div>

                    <div className="mt-4 mt-md-5 text-center">
                      <p className="mb-0">
                        © {new Date().getFullYear()} MILDMAY
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default PublicApplicantsRegister;
